import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ConvertMaster from './pages/ConvertMaster';
import PrivacyPage from './pages/PrivacyPage';
import { LanguageProvider } from './contexts/LanguageContext';
import { AppStateProvider } from './contexts/AppStateContext';
import SEOHead from './components/SEOHead';
import './App.css';

function App() {
  return (
    <LanguageProvider>
      <AppStateProvider>
        <SEOHead />
        <div className="app">
          <Routes>
            <Route path="/" element={<ConvertMaster />} />
            <Route path="/tool/:toolId" element={<ConvertMaster />} />
            <Route path="/privacy" element={<PrivacyPage />} />
          </Routes>
        </div>
      </AppStateProvider>
    </LanguageProvider>
  );
}

export default App;